import { cn } from "@/lib/utils";

export default function Logo({ className = "", variant = "light", compact = false }) {
    // variant: light (for dark bg) | dark (for light bg)
    const textColor = variant === "light" ? "text-white" : "text-neutral-900";
    const subColor = variant === "light" ? "text-neutral-400" : "text-neutral-500";
    return (
        <div className={cn("flex items-center gap-2.5 select-none", className)}>
            <div className="relative h-9 w-9 shrink-0">
                <div className="absolute inset-0 rounded-xl bg-[hsl(var(--brand))] shadow-brand" />
                <div className="absolute inset-0 flex items-center justify-center font-extrabold text-white text-[15px] tracking-tight">
                    OMB
                </div>
            </div>
            {!compact && (
                <div className="leading-tight">
                    <div className={cn("font-bold text-[15px] tracking-tight", textColor)}>
                        OMB
                        <span className="text-[hsl(var(--brand))]">.</span>
                        <span className={textColor}>Agency</span>
                    </div>
                    <div className={cn("text-[10px] font-medium tracking-[0.15em] uppercase", subColor)}>
                        ERP PRO
                    </div>
                </div>
            )}
        </div>
    );
}
